module.exports = __webpack_public_path__ + "img/appstore_white.9a2913a4.svg";